'use es6';

import { Map as ImmutableMap, Set as ImmutableSet } from 'immutable';
import PropTypes from 'prop-types';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { TableHoverCell } from 'foundations-components/transitional/components/Table';
import { getName, getReportOwnerUser, getUpdatedByUser, getUpdatedAt, getBusinessUnitId } from 'reporting-action-components/data/schemas/reportSchema';
import CheckboxCell from '../cells/CheckboxCell';
import BusinessUnitCell from '../cells/BusinessUnitCell';
import UserCell from '../cells/UserCell';
import DateCell from '../cells/DateCell';
import useRestoreReportsProblem from '../../../lib/useRestoreReportsProblem';
import { Button } from 'foundations-components/transitional/components/Button';
import I18n from 'I18n';
import { useHasReportingCreateAndOwnAccess } from 'reporting-action-components/access/scopes/hooks/useHasScope';
import { useShowDialog } from 'reporting-action-components/dialog/ducks';
import { RESTORE_REPORT_DIALOG } from 'reporting-action-components/dialog/dialogTypes';
import { useDispatch } from 'react-redux';
import { getRestorableReports, getReportCounts } from '../../../actions/reportsActions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RestoreReportsTableRow = ({
  buOptions,
  report,
  onSelectedChange,
  selectedRows
}) => {
  const dispatch = useDispatch();
  const showDialog = useShowDialog();
  const hasReportingCreateAndOwnAccess = useHasReportingCreateAndOwnAccess();
  const isSelected = selectedRows.includes(report);
  const {
    problem: selectionProblem,
    disabledMessage: selectionDisabledMessage
  } = useRestoreReportsProblem({
    reports: selectedRows.add(report)
  });
  const selectionDisabled = !isSelected && !!selectionProblem;
  const {
    problem: restoreProblem
  } = useRestoreReportsProblem({
    reports: ImmutableSet([report])
  });
  const isRestoreDisabled = !hasReportingCreateAndOwnAccess || !!restoreProblem;
  const handleRestore = () => {
    const reports = ImmutableSet([report]);
    showDialog({
      dialogType: RESTORE_REPORT_DIALOG,
      dialogProps: {
        reports,
        onRestoreReportSuccess: () => {
          dispatch(getReportCounts());
          dispatch(getRestorableReports());
        }
      }
    });
  };
  return /*#__PURE__*/_jsxs("tr", {
    children: [/*#__PURE__*/_jsx(CheckboxCell, {
      isDisabled: selectionDisabled,
      isSelected: isSelected,
      handleSelectedChange: ({
        target: {
          checked
        }
      }) => onSelectedChange(report, checked),
      tooltipMessage: selectionDisabledMessage
    }), /*#__PURE__*/_jsx(TableHoverCell, {
      hoverContent: !isRestoreDisabled ? /*#__PURE__*/_jsx(Button, {
        use: "tertiary-light",
        size: "xs",
        onClick: handleRestore,
        children: I18n.text('reports.restore.table.header.restoreAction.label')
      }) : null,
      children: /*#__PURE__*/_jsx(TruncateString, {
        tooltip: true,
        children: getName(report)
      })
    }), /*#__PURE__*/_jsx(UserCell, {
      user: getReportOwnerUser(report)
    }), /*#__PURE__*/_jsx(BusinessUnitCell, {
      buId: getBusinessUnitId(report),
      buOptions: buOptions
    }), /*#__PURE__*/_jsx(UserCell, {
      user: getUpdatedByUser(report),
      userId: report.get('updatedBy'),
      isRestoreReportsCell: true
    }), /*#__PURE__*/_jsx(DateCell, {
      timestamp: getUpdatedAt(report)
    })]
  });
};
RestoreReportsTableRow.propTypes = {
  buOptions: PropTypes.array,
  report: PropTypes.instanceOf(ImmutableMap).isRequired,
  onSelectedChange: PropTypes.func.isRequired,
  selectedRows: PropTypes.instanceOf(ImmutableSet).isRequired
};
export default RestoreReportsTableRow;